import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

const badgeVariants = cva(
    'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ring-1 ring-inset transition-all duration-200',
    {
        variants: {
            variant: {
                success: 'bg-success/10 text-success ring-success/20',
                warning: 'bg-warning/10 text-warning-foreground ring-warning/20',
                error: 'bg-error/10 text-error ring-error/20',
                info: 'bg-brand-trust/10 text-brand-trust ring-brand-trust/20',
                available: 'bg-success/10 text-success ring-success/20',
                pending: 'bg-warning/10 text-warning-foreground ring-warning/20',
                adopted: 'bg-muted/50 text-muted-foreground ring-muted/20',
                notAvailable: 'bg-error/10 text-error ring-error/20',
                default: 'bg-muted text-muted-foreground ring-border',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> { }

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
    ({ className, variant, ...props }, ref) => {
        return (
            <div ref={ref} className={badgeVariants({ variant, className })} {...props} />
        );
    }
);

Badge.displayName = 'Badge';

export default Badge;
